import {lorem} from "./Utils";
import {ASSETS, DEBUG, ORDER, MAX_YEAR, MIN_YEAR} from "./Constants";

export default function template() {
	return `
	<div id="graphic">
		<div id="ui">
			<div id="legend">
				<div id="scale"></div>
			</div>
			<div id="tooltip">
				<div class="tooltip"></div>
			</div>
		</div>
		<!-- canvas -->
			<div id="map" ${DEBUG ? `class="debug"` : ``}>
				<div id="pane">
					<div class="caption"></div>
				</div>
				${DEBUG ? `<div id="debug"></div>` : ``}
				<div id="underlay"><div id="axes"></div></div>
				<div id="overlay">
					<div id="labels"></div>
					<div id="labels1"></div>
					<div id="labels2"></div>
				</div>
			</div>
			<div id="sections">
			
			<section class="step" data-step="95"  data-layout="global_scatter" data-min_year="${MAX_YEAR}" data-max_year="${MAX_YEAR}" >
				<p>In this scatterplot, each square represents a country. A square’s placement indicates the severity of restrictions in that country on our <strong>Government Restrictions Index</strong> (GRI) and our <strong>Social Hostilities Index</strong> (SHI). The color of each square represents the corresponding country’s region of the world. </p>
			</section>
			<section class="step" data-step="96"  data-layout="global_scatter" data-min_year="${MAX_YEAR}" data-max_year="${MAX_YEAR}">
				<p>In 2022, Afghanistan, Egypt, Iraq, Pakistan and Syria had “very high” GRI and SHI scores. In Syria, <a href="https://www.state.gov/reports/2022-report-on-international-religious-freedom/syria/">the government and its allies continued to target opponents</a> – most of them Sunni Muslims who the government associated with extremism. Meanwhile, armed opposition groups backed by Turkey (known as TSOs) attacked ethnic and religious minorities, such as the Yazidis, and destroyed their places of worship in 2022.</p>
				<p>In Iraq, media and human rights organizations said security conditions improved in 2022, but they also reported that <a href="https://www.state.gov/reports/2022-report-on-international-religious-freedom/iraq/">“sectarian armed groups” violently targeted minority groups</a> that year.</p>
			</section>
			<section class="step" data-step="97"  data-layout="scatter"  data-center="818" data-min_year="2007" data-max_year="${MAX_YEAR}" >
				<p>Each country’s GRI and SHI scores are calculated annually to reflect events that occurred in that country. Between 2007 and ${MAX_YEAR}, for example, Egypt’s GRI and SHI scores were “high” or “very high,” as shown in the accompanying graphic.</p>
			</section>
			<section class="step" data-step="98"  data-layout="global_scatter" data-min_year="${MAX_YEAR}" data-max_year="${MAX_YEAR}" >
				<div><p>To view levels of religious restrictions in any of the almost 200 countries and territories included in the study, use the search bar or select a square from the scatterplot by clicking on it.</p></div>
				<div class="close">${this.renderDropdown()}</div>
				<div class="country-info"></div>
				<div class="ui basic buttons"><div class="ui button active year">${MAX_YEAR}</div><div class="ui button trend">${MIN_YEAR}-${MAX_YEAR} trend</div></div>
			</section>
				<!--End-->

			</div><!-- /sections -->
		</div><!-- /graphic -->
	`;
}
